import cn from 'classnames';
import { FC, HTMLProps } from 'react';
import s from './version.module.css';
import { useVersion } from './use-version';
import { Loader } from '../../components/loader/loader';

export const Version: FC<HTMLProps<HTMLDivElement>> = (props) => {
  const { className, ...other } = props;

  const { savedVersion, isLoading } = useVersion();

  return (
    <div className={cn(s.feature, className)} {...other}>
      {isLoading && <Loader />}
      <p>QR Informer</p>
      <p>v.{savedVersion}</p>
    </div>
  );
};
